export const SET_MEDIA_TYPES = 'SET_MEDIA_TYPES'
export const REFRESH_MEDIA_STYPES = 'REFRESH_MEDIA_STYPES'
